import { render, staticRenderFns } from "./QuizType.vue?vue&type=template&id=50a7897a&"
import script from "./QuizType.vue?vue&type=script&lang=js&"
export * from "./QuizType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports